import loadable from "@loadable/component";
import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import "./styles/normalize.css";
import "./styles/main.css";
import { ThemeProvider } from "styled-components";
import { dark, light } from "./styles/Theme.styled";
import GlobalStyles from "./styles/Global";
//import page components
import Home from "./pages/Home";
import JumpToTop from "./components/JumpToTop";

import SharedLayout from "./pages/SharedLayout";

const Contact = loadable(() => import("./pages/Contact"));
const Projects = loadable(() => import("./pages/Projects"));
const Error = loadable(() => import("./pages/Error"));
const Project = loadable(() => import("./pages/Project"));
const NotesPage = loadable(() => import("./pages/NotesPage"));

function App() {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [fileName, setFileName] = useState("webpack5.md");
  const [docNavIsOpen, setDocNavIsOpen] = useState(false);
  const [theme, setTheme] = useState(() => {
    let tempTheme = localStorage.getItem("localTheme");
    let tempDeviceTheme = window.matchMedia(
      "(prefers-color-scheme: light)"
    ).matches;
    if (tempTheme !== null) {
      if (tempTheme === "true") {
        return light;
      } else {
        return dark;
      }
    } else {
      if (tempDeviceTheme) {
        localStorage.setItem("localTheme", "true");
      } else {
        localStorage.setItem("localTheme", "false");
      }
      return tempDeviceTheme ? light : dark;
    }
  });

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <JumpToTop>
          <Routes>
            <Route
              path="/"
              element={
                <SharedLayout
                  sidebarIsOpen={sidebarIsOpen}
                  setSidebarIsOpen={setSidebarIsOpen}
                  setDocNavIsOpen={setDocNavIsOpen}
                  docNavIsOpen={docNavIsOpen}
                  theme={theme}
                  setTheme={setTheme}
                />
              }
            >
              <Route index element={<Home />}></Route>
              <Route element={<Contact />} path="/contact"></Route>
              <Route
                path="/course-notes"
                element={
                  <NotesPage
                    setFileName={setFileName}
                    fileName={fileName}
                    docNavIsOpen={docNavIsOpen}
                    setDocNavIsOpen={setDocNavIsOpen}
                  />
                }
              />
              <Route element={<Projects />} path="/projects"></Route>
              <Route element={<Project />} path="/project/:projectID" />

              <Route path="*" element={<Error />} />
            </Route>
          </Routes>
        </JumpToTop>
        <ScrollToTop
          smooth
          className="scroll-top"
          color={
            theme === dark ? "var(--secondary-1200)" : "var(--primary-600)"
          }
          top="800"
          height="50"
          width="50"
        />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
